import { CompetencyStatus } from './types'

export const STATUS_LABELS: Record<CompetencyStatus, string> = {
  proficient: 'Proficient',
  competent: 'Kompetent',
  in_progress: 'In Arbeit',
  not_yet_competent: 'Noch nicht sicher',
  not_attempted: 'Nicht gestartet'
}

export const STATUS_DESCRIPTIONS: Record<CompetencyStatus, string> = {
  proficient: 'Übertrifft die Anforderungen und zeigt sicheren Umgang mit der Kompetenz.',
  competent: 'Beherrscht die Kompetenz sicher und zuverlässig.',
  in_progress: 'Diese Kompetenz ist in Bearbeitung.',
  not_yet_competent: 'Hier besteht noch Übungsbedarf.',
  not_attempted: 'Für diese Kompetenz liegen noch keine Aktivitäten vor.'
}

export const STATUS_BADGE_STYLES: Record<CompetencyStatus, string> = {
  proficient: 'bg-emerald-100 text-emerald-700',
  competent: 'bg-lime-100 text-lime-700',
  in_progress: 'bg-amber-100 text-amber-700',
  not_yet_competent: 'bg-orange-100 text-orange-700',
  not_attempted: 'bg-gray-200 text-gray-600'
}

export const STATUS_RING_COLORS: Record<CompetencyStatus, string> = {
  proficient: '#10b981',
  competent: '#22c55e',
  in_progress: '#f59e0b',
  not_yet_competent: '#f97316',
  not_attempted: '#6b7280'
}

export const ROOT_LEVEL_COLORS: Array<{ bg: string; border: string }> = [
  { bg: '#eff6ff', border: '#3b82f6' },
  { bg: '#f0fdf4', border: '#22c55e' },
  { bg: '#fefce8', border: '#eab308' },
  { bg: '#fef3c7', border: '#f59e0b' },
  { bg: '#fce7f3', border: '#ec4899' },
  { bg: '#f3e8ff', border: '#a855f7' },
  { bg: '#e0f2fe', border: '#06b6d4' },
  { bg: '#ecfccb', border: '#84cc16' },
  { bg: '#fff1f2', border: '#f43f5e' },
  { bg: '#fff7ed', border: '#fb923c' }
]
